module.exports = __webpack_public_path__ + "static/media/comment-alt-slash.9047c181.svg";